module.exports = __webpack_public_path__ + "img/2794f31.svg";